import React from "react";
import { Box, Grid, Card, Typography } from "@material-ui/core";
import { Phone, Email, LocationOn } from "@material-ui/icons";

import "./AppFooter.css";

function AppFooter({ open, profileDetail }) {
  const url = window.location.href;
  const isGuestRoute = url.split("/").slice(-1)[0].toLowerCase().includes("guest");

  // Không hiển thị footer trên trang guest
  if (isGuestRoute) return null;

  return (
    <Card
      id="app-footer"
      style={{
        left: isGuestRoute && !profileDetail ? 0 : open ? 250 : 80,
      }}
    >
      <Grid container id="footer-content" spacing={1} alignItems="center">
        {/* <Grid item xs={12} md={4}>
          <Box display="flex" alignItems="center" justifyContent={{ xs: "center", md: "flex-start" }}>
            <LocationOn color="primary" style={{ marginRight: 8, fontSize: 18 }} />
            <Typography variant="body2" color="primary">
              <strong>VINUNIVERSITY</strong>
            </Typography>
          </Box>
        </Grid> */}

        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" justifyContent={{ xs: "center", md: "flex-start" }}>
            <Phone color="primary" style={{ marginRight: 8, fontSize: 18 }} />
            <Typography variant="body2" color="primary">
              <strong>(84)247.108.9779</strong>
            </Typography>
          </Box>
        </Grid>

        <Grid item xs={12} md={6}>
          <Box display="flex" alignItems="center" justifyContent={{ xs: "center", md: "flex-end" }}>
            <Email color="primary" style={{ marginRight: 8, fontSize: 18 }} />
            <Typography variant="body2" color="primary">
              <strong>research@vinuni.edu.vn</strong>
            </Typography>
          </Box>
        </Grid>
      </Grid>
    </Card>
  );
}

export default AppFooter;

